import IHDM_Image from "assets/images/Ihdm_image.png";
import IGPCM_Image from "assets/images/igpcm_image.png";
// import SimplifyBlog_Image from "assets/images/simplifyBlog_image.png";
import Goboomit_Image from "assets/images/Goboomit.png";
import SimpuGo_Banner from "assets/images/simpuBanner.png";
import Luupli_Banner from "assets/images/Luupli_banner.png";
import Monie_Image from "assets/images/Monie_image.png";
import DailyTask_Image from "assets/images/Dailytask_image.png";
import Dhac_Image from "assets/images/Dhac_Banner.png";

export const experience_data = [
  {
    title: "Lead  Mobile Engineer",
    description:
      "As a leader in mobile development, I oversaw the entire application lifecycle, from initial architecture and development through to successful deployment. I managed a team of skilled engineers, guiding key technical decisions to ensure robust code quality, scalability, and strict adherence to industry best practices. My role was instrumental in driving performance optimization and the consistent delivery of new features across the platform.",
    company: "Luupli",
    location: "London, UK",
    from: "Jan,2024",
    to: "Present",
  },
  {
    title: "Senior Mobile Engineer (Part time)",
    description:
      "As a senior engineer at Launch legends, I translated complex designs into high-performing, scalable React Native modules. By collaborating with product and backend teams, I was instrumental in defining features, optimizing APIs, and boosting performance. My commitment to clean architecture and reusable components laid a sustainable foundation for the application, while my oversight of deployments, versioning, and continuous improvements ensured a smooth and reliable release cycle.",
    company: "Launch Legend",
    location: "Wyoming, United States",
    from: "Nov,2024",
    to: "Jun, 2025",
  },
  {
    title: "Mobile Engineer",
    description:
      "My task at Simpu Inc, include supporting the entire application development lifecycle, producing functional mobile apps with clean code, conducting testing, troubleshooting and optimizing performance, designing user interfaces for better user experiences, researching and proposing new mobile technologies, staying updated on tech trends, fixing bugs, and making recommendations for improvements.",
    company: "Simpu Inc",
    location: "San Francisco, CA",
    from: "May,2022",
    to: "Oct, 2025",
  },
  {
    title: "Full-Stack Developer",
    description:
      "Buit and currently Managing the IHDM and IGPCM portals, for data records and exam registration. ",
    company: "IHDM (Institute of Humanitarian and Disaster Management)",
    location: "Abuja, Nigeria",
    from: "September, 2020",
    to: "Dec, 2024",
  },
  {
    title: "Front-End Developer/Site Reliability Engineer",
    description:
      "Building and management of the Simplify Blog, Mange and review pr’s, maintaining branches, setting up continuous integration and continuous delivery (CI/CD) pipelines, and reviewing code changes, troubleshooting both technical and process-related issues to ensure sustained productivity, and ensuring system functionality through rigorous testing.",
    company: "Mercator Technologies Ltd",
    location: "Lekki Lagos",
    from: "October, 2019",
    to: "May, 2022",
  },

  {
    title: "Network Administrator",
    description:
      "As a system administrator at UPSL, my duties includes monitoring scheduled tasks, ensuring accurate computer output, performing data backups, updating firmware and security measures, managing Microsoft Active Directory, configuring and maintaining various security systems, and assisting with software upgrades and installations to ensure the smooth and secure operation of IT systems.",
    company: "Unified Payment Services Limited",
    location: "3, Idowu Taylor,Victoria Island Lagos",
    from: "May, 2018",
    to: "October, 2018",
  },
];

export const education_data = [
  {
    title: "Mobile Web Specilist(MWS)",
    description: "",
    company: "Google Africa Developer Scholarship",
    location: "",
    from: "",
    to: "2021",
  },
  {
    title: "BSc(Hons) Computer Science.",
    description: "",
    company: "Federal University Gashu’a,",
    location: "Yobe State. Nigeria",
    from: "",
    to: "2019",
  },
  {
    title: "Cisco Certified Network Associate(CCNA)",
    description: "",
    company: "Deft-Rains Solutions Nigeria",
    location: "Lagos State. Nigeria",
    from: "",
    to: "2015",
  },
  {
    title: "National Diploma(Computer Engineering)",
    description: "",
    company: "Lagos State Polytechnic",
    location: "Lagos State. Nigeria",
    from: "",
    to: "2013",
  },
];

export const TechStack = {
  HTML: "html",
  CSS: "css",
  JAVASCRIPT: "javascript",
  NODEJS: "NodeJs",
  TYPESCRIPT: "typescript",
  REACTJS: "ReactJS",
  NEXTJS: "NextJS",
  REACTNATIVE: "ReactNative",
  ELECTRON: "ElectronJS",
  ANGULAR: "AngularJS",
  TAILWIND: "TailwindCss",
  GIT: "Git",
  MONGODB: "Mongo DB",
  JEST: "Jest (Testing)",
  FIREBASE: "Firebase",
  DOCKER: "Docker",
  EXPRESSJS: "ExpressJS",
  NESTJS: "NestJS",
  POSTGRES: "PostgreSQL",
};

export const StackType = {
  FRONTEND: "frontend",
  BACKEND: "backend",
  DATABASE: "database",
  TOOL: "tool",
};

export const TeckStack = [
  {
    name: TechStack.HTML,
    type: StackType.FRONTEND,
  },
  {
    name: TechStack.CSS,
    type: StackType.FRONTEND,
  },
  {
    name: TechStack.TAILWIND,
    type: StackType.FRONTEND,
  },
  {
    name: TechStack.JAVASCRIPT,
    type: StackType.FRONTEND,
  },
  {
    name: TechStack.TYPESCRIPT,
    type: StackType.FRONTEND,
  },
  {
    name: TechStack.REACTJS,
    type: StackType.FRONTEND,
  },
  {
    name: TechStack.NEXTJS,
    type: StackType.FRONTEND,
  },
  {
    name: TechStack.REACTNATIVE,
    type: StackType.FRONTEND,
  },
  {
    name: TechStack.ELECTRON,
    type: StackType.FRONTEND,
  },
  {
    name: TechStack.ANGULAR,
    type: StackType.FRONTEND,
  },
  {
    name: TechStack.NODEJS,
    type: StackType.BACKEND,
  },
  {
    name: TechStack.EXPRESSJS,
    type: StackType.BACKEND,
  },
  {
    name: TechStack.NESTJS,
    type: StackType.BACKEND,
  },
  {
    name: TechStack.GIT,
    type: StackType.TOOL,
  },
  {
    name: TechStack.MONGODB,
    type: StackType.DATABASE,
  },
  {
    name: TechStack.POSTGRES,
    type: StackType.DATABASE,
  },
  {
    name: TechStack.JEST,
    type: StackType.TOOL,
  },
  {
    name: TechStack.FIREBASE,
    type: StackType.DATABASE,
  },
  {
    name: TechStack.DOCKER,
    type: StackType.TOOL,
  },
];

export const ProjectType = {
  WEB: "web",
  MOBILE: "mobile",
  DESKTOP: "desktop",
};
export const Project_data = [
  {
    type: ProjectType.MOBILE,
    name: "Dhac App",
    projectImage: Dhac_Image,
    description:
      "Dhac, an app connecting truck owners with verified CDL drivers. Monetize idle vehicles or lease quality trucks with flexible terms and secure payments.",
    repo: "",
    link: "https://www.dhac.app/",
    appStoreLink: "",
    playStoreLink: "",
    technologies: [
      "React-Native",
      "React-Query",
      "Maps",
      "Geo-location",
      "Websocket",
    ],
  },
  {
    type: ProjectType.MOBILE,
    name: "Luupli",
    projectImage: Luupli_Banner,
    description:
      "luupli, the revolutionary social media platform that empowers genuine self-expression and promotes authentic human connections. Join a diverse global community where your voice takes center stage.",
    repo: "",
    link: "https://apps.apple.com/gb/app/luupli/id6463861554",
    appStoreLink: "https://apps.apple.com/gb/app/luupli/id6463861554",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=com.dev.luupli.uat&hl=en",
    technologies: ["React-Native", "React-Query", "Firebase", "Websocket"],
  },
  {
    type: ProjectType.MOBILE,
    name: "SimpuGO",
    projectImage: SimpuGo_Banner,

    description:
      "Simpu is the all-in-one communication platform for your teams' and customer interaction needs from email, social media, SMS to Live chat.",
    repo: "",
    link: "https://play.google.com/store/apps/details?id=co.simpu.inbox",
    appStoreLink: "https://apps.apple.com/us/app/simpugo/id1645026323",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=co.simpu.inbox",
    technologies: ["React-Native", "React-Query", "UI-kitten", "Firebase"],
  },
  {
    type: ProjectType.MOBILE,
    name: "Goboomit",
    projectImage: Goboomit_Image,

    description:
      "Goboomit is a platform that makes it easy for influencers and businesses to collaborate. Paving the way for good cooperation between our influencers and their partners. we also have a strong focus on companies and their campaigns, so on goboomit, you can find all kinds of products, companies and campaigns",
    repo: "",
    link: "https://play.google.com/store/apps/details?id=com.goboomit",
    appStoreLink:
      "https://apps.apple.com/us/app/goboomit/id6444501062?platform=iphone",
    playStoreLink: "https://play.google.com/store/apps/details?id=com.goboomit",
    technologies: ["React-Native", "Expo", "Firebase"],
  },
  {
    type: ProjectType.MOBILE,
    name: "Moniee Mobile",
    projectImage: Monie_Image,

    description:
      "Moniee is a mobile fintech app for sending and recieving funds directly to anyone from your contact. ",
    repo: "https://github.com/tdammy92/Moniee",
    link: "https://drive.google.com/file/d/1-LImj4UBOstDWKjDeEw1JBTvtLxthN30/view?usp=drive_link",
    appStoreLink: "",
    playStoreLink: "",
    technologies: ["React-Native", "Async-storage", "redux"],
  },
  {
    type: ProjectType.MOBILE,
    name: "DailyTask",
    projectImage: DailyTask_Image,
    description:
      "Daily Task is a close replica of google task, with more features such as nested List.",
    repo: "",
    link: "https://drive.google.com/file/d/1JPX3IRVUXNLTu94DACJzR1CPyE9F6H3Y/view?usp=drive_link",
    appStoreLink: "",
    playStoreLink: "",
    technologies: ["React-Native", "Async-storage", "Firebase"],
  },
  {
    type: ProjectType.WEB,
    name: "IHDM Portal",
    projectImage: IHDM_Image,
    description:
      "Ihdm portal, is owned by a research body, that conducts independent result-based research on vulnerable communities, carries out public education and training, advance policy advocacy.",
    repo: "https://github.com/tdammy92/ihdm-web",
    link: "https://ihdm.org.ng/",
    technologies: ["ReactJS", "MaterialUI", "Node/StrapiJs", "MongoDb"],
  },
  {
    type: ProjectType.WEB,
    name: "IGPCM Portal",
    projectImage: IGPCM_Image,
    description:
      "A Registration portal, IGPCM professionally raises, trains and primes individuals and corporate bodies, with practical skills training, in peace building.",
    repo: "https://github.com/tdammy92/ipcm-web",
    link: "https://igpcm.com.ng/",
    technologies: ["ReactJS", "MaterialUI", "NodeJs", "MongoDb", "Cloudinary"],
  },
  // {
  //   type: ProjectType.MOBILE,
  //   name: "FugaGpa",
  //   projectImage:
  //     "https://twproject.com/blog/wp-content/uploads/how-to-manage-project-integration.png",
  //   description:
  //     "FugaGpa is a mobile app for student of the federal university gashua, which serves as a guild to many things on campus like GPA calculation, Time table, Library etc.",
  //   repo: "https://github.com/tdammy92/FugaApp",
  //   link: "https://drive.google.com/file/d/1h0soxyODfMDt9tnlkgIMTTcaCzTaRS8I/view?usp=sharing",
  //   technologies: ["React-Native"],
  // },
  // {
  //   type: ProjectType.WEB,
  //   name: "Simplify Blog",
  //   projectImage: SimplifyBlog_Image,
  //   description:
  //     "The Blog is a journal to provide insight, about Simpilify, which is a simple and modern point of sales with integrated inventory management system for growing businesses.",
  //   repo: "",
  //   link: "https://simplifyblog.netlify.app/",
  //   technologies: ["GatsbyJS", "CSS", "Node/StrapiJs", "MongoDb", "Cloudinary"],
  // },
  // {
  //   type: ProjectType.DESKTOP,
  //   name: "Tic Tac Toa (XandO)",
  //   projectImage:
  //     "https://twproject.com/blog/wp-content/uploads/how-to-manage-project-integration.png",
  //   description:
  //     "XandO popularly known as Tic Tac Toe Electron-react App for Desktop PC/Mac and linux",
  //   repo: "https://github.com/tdammy92/XandO",
  //   link: "",
  //   technologies: ["ElectronJS", "CSS"],
  // },
];
